var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: _vm.dragFilter,
      expression: "dragFilter",
      arg: "pan"
    }, {
      name: "hammer",
      rawName: "v-hammer:panend",
      value: _vm.dragEndFilter,
      expression: "dragEndFilter",
      arg: "panend"
    }],
    ref: "filter",
    staticClass: "card",
    style: [_vm.computedFilterY, _vm.computedFilterX, _vm.computedWidth]
  }, [_c('v-card-title', {
    staticClass: "pb-4"
  }, [_c('span', [_vm._v("Фильтры")]), _c('v-spacer'), _c('v-icon', {
    staticClass: "mr-1 close-btn",
    attrs: {
      "color": "lightGrey",
      "size": "22",
      "title": "Закрыть"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" mdi-close ")])], 1), _c('v-card-text', {
    staticClass: "pt-3 filter border-top"
  }, [_c('v-row', {
    staticClass: "pt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    staticClass: "pa-0",
    attrs: {
      "items": _vm.sortedYears,
      "item-text": "name",
      "label": "Год",
      "placeholder": "Выберите год",
      "dense": "",
      "clearable": "",
      "return-object": "",
      "outlined": "",
      "rounded": ""
    },
    on: {
      "change": _vm.applyFilter
    },
    model: {
      value: _vm.localFilter.year,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilter, "year", $$v);
      },
      expression: "localFilter.year"
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey",
      "disabled": _vm.disabledBtn
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Сбросить")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }